export default {
  id: 234,
  title: 'Target #234 - Pieces',
  url: 'https://cssbattle.dev/play/234',
  colors: ['#1FBCB5', '#F9F8F4', '#074760', '#FFB43D'],
  solution:
    '<p a><p b><p c><p d><style>p[b],p[c]{border-radius:9in}p[b],p[c],p[d]{width:40;height:40;rotate:45deg}body{background:#1fbcb5}p{position:fixed;margin:0}p[a]{top:150;left:120;width:80;height:80;background:#074760;box-shadow:80px 0 #f9f8f4}p[b]{top:70;left:120;border:60px solid #f9f8f4;border-right-color:#1fbcb5}p[c]{top:90;left:140;border:40px solid #ffb43d;border-right-color:#1fbcb5}p[d]{top:110;left:160;background:linear-gradient(-45deg,#f9f8f4 28px,#1fbcb5 28px);border-radius:9in;border:20px solid #074760;border-right-color:#1fbcb5',
}
